import React from "react"
import styled from "styled-components"
import { rem } from "polished"
import { media } from "@sr/common"
import { SemiBdTitle4 } from "@sr/gatsby-theme-ui"
import { Link } from "gatsby"

export interface CaseStudyEntryCtaPropsShape {
  text: string
  btnText: string
  btnLink: string
}

const CaseStudyEntryCta = ({
  text,
  btnText,
  btnLink,
}: CaseStudyEntryCtaPropsShape) => {
  if (!text || !btnText || !btnLink) return null
  return (
    <CaseStudyEntryCtaStyled>
      <div className="case-study-cta__container">
        <div className="case-study-cta__container-content">
          <SemiBdTitle4 className="case-study-cta__text">{text}</SemiBdTitle4>
          <Link to={btnLink}>
            <button className="case-study-cta__btn">
              <p>{btnText}</p>
            </button>
          </Link>
        </div>
      </div>
    </CaseStudyEntryCtaStyled>
  )
}

export default CaseStudyEntryCta

const CaseStudyEntryCtaStyled = styled.section`
  padding-top: ${rem(72)};

  @media ${media.midUp} {
    padding-top: ${rem(104)};
  }

  @media ${media.stMidUp} {
    padding-top: ${rem(96)};
  }

  .case-study-cta__container {
    display: flex;
    justify-content: center;
    background: var(--color-primary);
    min-height: ${rem(168)};
    height: fit-content;
    @media ${media.stMidUp} {
      padding: 0 ${rem(152)};
    }
  }

  .case-study-cta__container-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${rem(16)};
    margin: 0 ${rem(64)};
    max-width: ${rem(1152)};

    @media ${media.midUp} {
      flex-direction: row;
      justify-content: space-between;
    }

    @media ${media.stMidUp} {
      gap: ${rem(50)};
    }
  }

  .case-study-cta__text {
    text-align: center;
    color: white;
    padding: ${rem(16)} 0;

    @media ${media.midUp} {
      text-align: left;
      font-size: ${rem(32)};
      max-width: ${rem(700)};
    }
  }

  .case-study-cta__btn {
    height: ${rem(40)};
    width: ${rem(191)};
    border-radius: ${rem(4)};
    color: var(--color-primary);
    background: white;
    font-size: ${rem(16)};
    font-weight: 600;
  }
`
